import { jsx } from 'react/jsx-runtime';
import { formatCurrency, pluralizeDays } from '../../../../helpers/fomatters.js';
import { OfferCard } from '../../OfferCard.js';
import '@sravni/react-design-system';
import '@sravni/react-design-system/lib/Typography';
import '../../components/WithIcon/WithIcon.module.scss.js';
import 'classnames';
import '../../components/CardIcon/CardIcon.module.scss.js';
import '@sravni/react-icons';
import '../../components/Rating/Rating.module.scss.js';
import '../../components/CardTitle/CardTitle.module.scss.js';
import { OfferParam } from '../../components/OfferParam/OfferParam.js';
import '../../components/OfferParams/OfferParams.module.scss.js';
import { MFOSubtitle } from '../../components/Subtitles/Subtitles.js';
import 'react';
import '../../components/Notifications/Notifications.module.scss.js';

var CardMFO = function (_a) {
    var bankName = _a.bankName, bankIcon = _a.bankIcon, badges = _a.badges, payment = _a.payment, sum = _a.sum, term = _a.term, controls = _a.controls, onClick = _a.onClick, rating = _a.rating, reviews = _a.reviews;
    return (jsx(OfferCard, { title: bankName, icon: bankIcon, badges: badges, controls: controls, subtitle: jsx(MFOSubtitle, {}), onClick: onClick, rating: rating, reviews: reviews, summary: [
            jsx(OfferParam, { label: "\u0421\u0443\u043C\u043C\u0430", value: formatCurrency(sum) }, 1),
            jsx(OfferParam, { label: "\u0421\u0440\u043E\u043A", value: "".concat(term, " ").concat(pluralizeDays(term)) }, 2),
            jsx(OfferParam, { label: "\u041A \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0443", value: formatCurrency(payment) }, 3),
        ] }));
};

export { CardMFO };
//# sourceMappingURL=CardMFO.js.map
